<template>
  <DataList
    title="Валюти"
    resource="crm-currencies"
    :columns="columns"
    :get-items-fn="getCurrency"
  />
</template>

<script>
import DataList from "../../../components/DataList.vue";
import * as currenciesApi from "../../backend/currenciesApi.js";

export default {
  components: {
    DataList,
  },
  data: () => ({
    columns: [
      { title: "Найменування", name: "title" },
      { title: "Код", name: "code" },
    ],
  }),
  methods: {
    async getCurrency(...args) {
      const entities = await currenciesApi.getCurrencies(args[0], args[1], args[2], args[3]);

      return entities;
    },
  },
};
</script>